




























































































import { AxiosError } from "axios";
import Vue, { VueConstructor } from "vue";
import { mapState } from "vuex";
import { Button, Icon, Input } from "ant-design-vue";
import { sendRegistrationEmail } from "@/api/kyc";
import { displayErrors } from "@/utils";

interface VuexBindings {
  token: string;
}

export default (Vue as VueConstructor<Vue & VuexBindings>).extend({
  name: "WelcomeEnter",

  data() {
    return {
      loading: false,
      email: "",
      message: "",
      status: "",
      agree: false
    };
  },

  components: {
    [Button.name]: Button,
    [Button.Group.name]: Button.Group,
    [Icon.name]: Icon,
    [Input.name]: Input
  },

  props: {
    lang: {
      type: String,
      default: "en"
    },
    code: {
      type: String,
      default: ""
    },
    state: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapState(["token"]),
    validEmail(): boolean {
      const reEmail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
      return reEmail.test(this.email);
    }
  },
  watch: {},

  methods: {
    getBtnType(lang: string = "") {
      return this.lang === lang ? "primary" : "default";
    },
    updateLang(lang: string = "") {
      if (lang !== this.lang) {
        this.$router.push({
          name: "kyc",
          params: { lang },
          query: this.$route.query
        });
      }
    },
    kycAgree() {
      if (this.state === 0) {
        const { lang } = this;
        this.$router
          .push({
            name: "kyc",
            params: { lang },
            query: { ...this.$route.query, state: "1" }
          })
          .catch(err => err);
      }
    },
    handlePressEnter(event: KeyboardEvent) {
      if (event.key === "Enter" && this.agree) {
        this.kycAgree();
      }
    },
    async sendEmail(email = "") {
      if (!this.validEmail) {
        return;
      }

      try {
        this.loading = true;
        const { message } = await sendRegistrationEmail(email);
        this.message = message;
        this.status = "success";
      } catch (err) {
        displayErrors(err);
        const { response } = err as AxiosError;
        this.message = response?.data?.message;
        this.status = "error";
      } finally {
        this.loading = false;
      }
    }
  },

  beforeUpdate() {
    window.removeEventListener("keyup", this.handlePressEnter);
  },
  updated() {
    window.addEventListener("keyup", this.handlePressEnter);
  },
  deactivated() {
    window.removeEventListener("keyup", this.handlePressEnter);
  },
  activated() {
    window.addEventListener("keyup", this.handlePressEnter);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handlePressEnter);
  },
  mounted() {
    window.addEventListener("keyup", this.handlePressEnter);
  }
});
